import events from '../../constants/events';

import { Base } from './Base';

import anime from 'animejs';

const classes = {
  flower: 'flower'
};

const selectors = {
  reveal: '[data-reveal]',
};

export class Reveal extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);

    this.items = [];

    this.init();
  }

  init() {
    this.setupIntersectionObserver();
    this.bindNewItemsListener();
  }

  setupIntersectionObserver() {
    this.observer = new IntersectionObserver((entries, observer) => {
      this.intersect(entries, observer);
    });

    this.items = Array.from(this.element.querySelectorAll(selectors.reveal));

    this.items.forEach(item => {
      this.observer.observe(item);
    });
  }

  bindNewItemsListener() {
    this.newItemsHandler = this.updateItems.bind(this);
    window.addEventListener(events.REVEAL_ITEMS_ADDED, this.newItemsHandler);
  }

  updateItems() {
    const items = Array.from(this.element.querySelectorAll(selectors.reveal));

    items.forEach((item) => {
      if (this.items.indexOf(item) === -1) {
        this.items.push(item);
        this.observer.observe(item);
      }
    });
  }

  intersect(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.reveal(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }

  reveal(target) {
    const targets = this.getTargets(target);

    if (target && target.classList && target.classList.contains(classes.flower)) {
      anime({
        targets: targets,
        opacity: [0, 1],
        duration: 750,
        delay: 275,
        easing: 'cubicBezier(0.47, 0.32, 0.29, 1.01)',
        begin: () => {
          target.style.visibility = 'visible';
        },
        complete: () => {
          target.style.visibility = 'visible'; // Needed as begin sometimes doesn't fire if page/tab isn't active
        }
      });
    } else {
      anime({
        targets: targets,
        opacity: [0, 1],
        translateY: [60, 0],
        duration: 750,
        transformOrigin: '0px 0px 0',
        delay: anime.stagger(100, { start: 150 }),
        easing: 'cubicBezier(0.47, 0.32, 0.29, 1.01)',
        begin: () => {
          target.style.visibility = 'visible';
        },
        complete: () => {
          target.style.visibility = 'visible'; // Needed as begin sometimes doesn't fire if page/tab isn't active
        }
      });
    }
  }

  getTargets(target) {
    let children = [];

    if (target && target.children && target.children.length > 1 && !target.classList.contains(classes.flower)) {
      Array.from(target.children).forEach((child) => {
        children.push(child);
      });
    } else {
      children = target;
    }

    return children;
  }

  cleanup() {
    this.items.forEach(item => {
      this.observer.unobserve(item);
    });

    window.removeEventListener(events.REVEAL_ITEMS_ADDED, this.newItemsHandler);
  }
}